import Swiper from '../autoload/_swiper';

class GalleryCarousel {

    doAThing() {
        console.log('animations Do a thing')

    }

    constructor(){

      console.log('GalleryCarousel')

        var swiperClass = '.gallery-swiper';

        $(swiperClass).each(function ( index ) {

          console.log('GalleryCarousel')

            var swiperID = 'gallery-' + index;
            var swiperIDHash = '#gallery-' + index;

            $(this).attr('id', swiperID);

            var homeSwiper = new Swiper(swiperIDHash, {
                slidesPerView: 'auto',
                centeredSlides: true,
                speed: 500,
                loop: true,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                spaceBetween: 10,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                on: {
                    init() {
                        setTimeout(() => {
                            window.dispatchEvent(new Event('resize'))
                        }, 200)
                    },
                },

            });

            homeSwiper.on('transitionStart', function () {

                //console.log('transitionStart');

            });

        });

    }
}

export default GalleryCarousel



// WEBPACK FOOTER //
// ./scripts/util/galleryCarousel.js